import React, {useEffect} from 'react';
import {Modal, Form, Input, Row, Col, Button} from 'antd';
import dayjs from "dayjs";

const ModalForm = ({
                       open,
                       onCancel,
                       onSubmit,
                       confirmLoading,
                       formItems,
                       title,
                       initialValues,
                       className,
                       rowIsUpdated
                   }) => {

    const [form] = Form.useForm();
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            onSubmit(values);
        } catch (error) {
            console.error('Validation Failed:', error);
        }
    };

    useEffect(() => {
        if (rowIsUpdated) {
            form.resetFields(); // Reset form fields when rowIsUpdated is true
        }
    }, [rowIsUpdated, form]);

    useEffect(() => {
        if (initialValues) {
            const transformedValues = {
                ...initialValues,
                birthDate: initialValues.birthDate ? dayjs(initialValues.birthDate) : null,
                registrationDate: initialValues?.registrationDate ? dayjs(initialValues.registrationDate) : null,
            };
            form.setFieldsValue(transformedValues);
        } else {
            form.resetFields();
        }
    }, [initialValues, form]);

    const handleReset = () => {
        form.resetFields();
    };

    return (
        <Modal
            title={title}
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            footer={[
                <Button key="reset" onClick={handleReset}>
                    Reset Fields
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk} loading={confirmLoading}>
                    Submit
                </Button>,
            ]}
            className={className}
        >
            <Form form={form} layout="vertical">
                {formItems.map((row, rowIndex) => (
                    <Row gutter={16} key={rowIndex}>
                        {row.map((item, colIndex) => (
                            <Col span={item.span} key={colIndex}>
                                <Form.Item
                                    key={item.name}
                                    label={item.label}
                                    name={item.name}
                                    rules={item.rules}
                                >
                                    {item.component || <Input/>}
                                </Form.Item>
                            </Col>
                        ))}
                    </Row>
                ))}
            </Form>
        </Modal>
    );
};

export default ModalForm;